import Shipment from "../../Models/Shipment";
import {Customer} from "../../Models/Customer";


export const GET_SHIPMENTS = "Shipment/getShipments";
export const SHIPMENTS_WITH_BILL = "Shipment/getShipmentsWithBill";

export const SHIPMENTS_BY_DAY = "SHIPMENTS_BY_DAY";
export const SHIPMENTS_BY_WEEK = "SHIPMENTS_BY_WEEK";
export const SHIPMENTS_BY_MONTH = "SHIPMENTS_BY_MONTH";
export const SHIPMENTS_BY_YEAR = "SHIPMENTS_BY_YEAR";

export type BY =
  typeof SHIPMENTS_BY_DAY |
  typeof SHIPMENTS_BY_WEEK |
  typeof SHIPMENTS_BY_MONTH |
  typeof SHIPMENTS_BY_YEAR;

export interface ShipmentsWithBillParams {
  start: Date,
  end: Date,
  by: BY,
  logged_customer_key:string;
}

export interface ShipmentSliceType {
  shipments: Shipment[];
  deliveredShipment: any[] | [];
  [SHIPMENTS_BY_DAY]: Shipment[];
  [SHIPMENTS_BY_WEEK]: Shipment[];
  [SHIPMENTS_BY_MONTH]: Shipment[];
  [SHIPMENTS_BY_YEAR]: Shipment[];
}

export interface ShipmentParams {
  customer?: Customer | string;
  status?: string;
}


export interface Interface {
  receiver: string,
  pickup_reception_date: string,
  delivery_date: string,
  customer_payment_type: string,
  group: string,
  subgroup: string,
  declared_value: string,
  variable_freight: string,
  total_value : string,
  receiver_signature?: string
}
